import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ContratoService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<any> {
		return this.http.get<any[]>(`${this.url}contrato`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public getOne(id: number): Observable<any[]> {
		return this.http.get<any[]>(`${this.url}contrato/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public finOnePedido(id: number): Observable<any[]> {
		return this.http.get<any[]>(`${this.url}contrato/pedido/${id}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public post(data: any): Observable<any> {
		return this.http.post<any>(`${this.url}contrato/create`, data, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	// public put(data: any, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}pedido/${id}`, {
	// 			id_cliente: data.id_cliente,
	// 		}, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
